import { create } from "zustand";
import { persist } from "zustand/middleware";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { getCurrentDateTime } from "../../../../../Common/helper/helpar";


const currentDate = new Date().toISOString().split("T")[0];

// Reusable fetch function with token
const fetchData = async (url) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

const useAttendanceFilterStore = create(
  persist(
    (set) => ({
      filters: {
        fromDate: "",
        toDate: "",
        zoneId: "",
      },
      zones: [],
      loading: false,

      setFilter: (filterKey, value) =>
        set((state) => ({
          filters: {
            ...state.filters,
            [filterKey]: value,
          },
        })),

      // Fetch zones
      fetchFilterZones: async () => {
        set({ loading: true });
        const data = await fetchData(`${API_BASE_URL1}MasterDetails/GetAllZone`);
        set({ zones: data, loading: false });
      },

      resetFilters: () =>
        set({
          filters: {
            fromDate: currentDate,
            toDate: currentDate,
            zoneId: "",
          },
        }),

      searchAttendanceReport: () => {
        // Fetch logic for attendance report based on filters
      },
    }),
    {
      name: "attendance-filters-storage", // localStorage key
    }
  )
);

export default useAttendanceFilterStore;
